module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }